import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    faqs: [],
    filters: {
      order_by: 'human_order',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addFaq({ commit }, { payload }) {
      const faq = await this.$axios.post(`${baseURLv1}/faq/`, payload);
      commit('add', ['faqs', faq.data.data]);
    },

    async editFaq({ commit }, { faq, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/faq/${id}/`, faq);

      commit('update', ['faqs', { id, payload: response.data.data }]);
    },

    async getFaqDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/faq/${id}/`);

      return response.data.data;
    },

    async deleteFaq({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/faq/${id}/`);

      commit('remove', ['faqs', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/faq/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['faqs', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
  },
};
